'use client';
import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import classnames from 'classnames';
import { Loading } from '../Loading/Loading.js';

const Button = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    children,
    variant = 'filled',
    color = 'primary',
    size = 'large',
    icon,
    disabled,
    loading,
    className = '',
    fontWeight,
    ...rest
  } = _ref;
  const Icon = icon?.component;
  const iconPosition = icon?.position || 'left';
  const LoadingIndicator = loading?.indicator || Loading;
  const classNames = classnames(className, 'b-btn', `b-btn--${size}`, `b-btn--${variant}`, `b-btn--${color}`, {
    'b-btn--icon-only': !children,
    'b-btn--loading': Boolean(loading?.state)
  }, fontWeight && `font-${fontWeight}`);
  return /*#__PURE__*/React__default.createElement("button", _extends({
    ref: ref,
    type: "button",
    "data-testid": "button",
    className: classNames,
    disabled: disabled || Boolean(loading?.state),
    "aria-label": rest['aria-label'] || children?.toString() || typeof Icon === 'function' && Icon?.displayName || 'Button'
  }, rest), Icon && iconPosition === 'left' && /*#__PURE__*/React__default.createElement("span", {
    className: children ? 'b-btn__icon b-btn__icon--left' : ''
  }, typeof Icon === 'function' ? /*#__PURE__*/React__default.createElement(Icon, null) : Icon), children && /*#__PURE__*/React__default.createElement("span", null, children), Icon && iconPosition === 'right' && /*#__PURE__*/React__default.createElement("span", {
    className: children ? 'b-btn__icon b-btn__icon--right' : ''
  }, typeof Icon === 'function' ? /*#__PURE__*/React__default.createElement(Icon, null) : Icon), Boolean(loading?.state) && /*#__PURE__*/React__default.createElement("span", {
    className: "b-btn__loading-indicator"
  }, /*#__PURE__*/React__default.createElement(LoadingIndicator, {
    size: loading?.size || 16
  })));
});
Button.displayName = 'Button';

export { Button };
